import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
interface TooltipProps {
  text: string;
}
export function Tooltip({
  text
}: TooltipProps) {
  const [show, setShow] = useState(false);
  return <span className="relative inline-flex items-center" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} data-id="element-166">
      <InfoIcon className="w-3.5 h-3.5 text-white/30 hover:text-salmon cursor-help transition-colors" data-id="element-167" />
      <AnimatePresence data-id="element-168">
        {show && <motion.div initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 4
      }} transition={{
        duration: 0.15
      }} className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-56 px-3 py-2 rounded-lg bg-black/95 border border-white/10 backdrop-blur-xl z-50" data-id="element-169">
            <p className="text-[11px] text-white/70 leading-relaxed font-medium" data-id="element-170">
              {text}
            </p>
            <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-black/95 border-r border-b border-white/10 rotate-45 -mt-1" data-id="element-171"></div>
          </motion.div>}
      </AnimatePresence>
    </span>;
}